// Presentation only: priority comes from the case, independent of type/ownership.
import "./visualV2.css";
export const visualPriority = (priority) => {
  const key = priority === "maxima" ? "alta" : priority;
  const tokens = {
    alta: { hex: "#FF453A", label: "ALTA" },
    media: { hex: "#FF9F0A", label: "MEDIA" },
    baja: { hex: "#0A84FF", label: "BAJA" },
  };
  return { ...(tokens[key] || { hex: "#8E8E93", label: "Sin prioridad confirmada" }),
    key: tokens[key] ? key : "unknown", text: "gv2-priority-text", border: "gv2-priority-border",
    soft: "gv2-neutral", badge: "gv2-priority-badge" };
};
export const locationFirst = (room, site) => [room, site].filter(Boolean).join(" · ");
export const eventSentence = (text) => text ? text.charAt(0).toUpperCase() + text.slice(1).toLocaleLowerCase("es-MX") : text;
